module.exports = __webpack_public_path__ + "static/media/login_img_Gyeonggi2.8cf41958.png";